export const isModalOpen = (modalRuntime: any, modalId: any) =>
  !!(modalRuntime && modalRuntime[modalId]);
